import React,{ useState, Children, ReactElement  } from 'react';

import './scss/HomePageCarousel.css';

interface HomePageCarouselProps {
  children: React.ReactNode;
}

export function HomePageCarousel({
  children,
}: HomePageCarouselProps) {
  const childArray = Children.toArray(children) as ReactElement[];
  const [currentSlide, setCurrentSlide] = useState(0);

  const multipleSlides = childArray.length > 1;

  const goToSlide = (index: number) => {
    setCurrentSlide((index + childArray.length) % childArray.length);
  };

  if (childArray.length === 0) {
    return null;
  }  

  if (!multipleSlides) {
    return <div className="single-slide">{childArray[0]}</div>;
  }

  const prevIndex = (currentSlide - 1 + childArray.length) % childArray.length;
  const nextIndex = (currentSlide + 1) % childArray.length;

return (
  <div className="carousel-wrapper">
  <div className="carousel-container">
    <div className="carousel-fixed-height">
      <div className="carousel-slide">
        <div className="logo preview left">
          {React.cloneElement(childArray[prevIndex], { isCenter: false })}
        </div>
        <button
          className="btn btn-icon border-0"
          aria-label="Previous Benefit"
          onClick={() => goToSlide(currentSlide - 1)}
        >
          <i className="ph-bold ph-caret-left"></i>
        </button>

        <div className="center-content">
          {React.cloneElement(childArray[currentSlide], { isCenter: true })}
        </div>


        <button
          className="btn btn-icon border-0"
          aria-label="Next Benefit"
          onClick={() => goToSlide(currentSlide + 1)}
        >
          <i className="ph-bold ph-caret-right"></i>
        </button>
        <div className="logo preview right">
          {React.cloneElement(childArray[nextIndex], { isCenter: false })}
        </div>
      </div>
    </div>
  </div>

  <div className="carousel-dots">
    {childArray.map((_, index) => (
      <button
        key={index}
        role="radio"
        className={`dot ${index === currentSlide ? 'active' : ''}`}
        onClick={() => goToSlide(index)}
        aria-label={`Go to slide ${index + 1}`}
        aria-checked={index === currentSlide}
      />
    ))}
  </div>
</div>
);
}
